<template>
<div class="col-6 d-flex justify-content-end px-0">
    <Button @click="dialogVisible = true" type="outline" color="grey" class="filter-button mx-1 px-3 py-2">
        <FilterIcon class="ml-0" size="16" color="#A1A8B8" />Filtrar
    </Button>
    <FiltersModal :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @empty="emptyFilters" @filter="filterRequest">
        <el-collapse>
            <el-collapse-item title="Perfil" name="1">
                <div class="d-flex flex-column">
                    <el-radio :class="getPrimaryColor" v-model="filters.userAllowedProfiles" label="2">Comprador</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.userAllowedProfiles" label="0">Financiador</el-radio>
                </div>
            </el-collapse-item>
            <el-collapse-item title="Situação cadastral" name="2">
                <div class="d-flex flex-column">
                    <el-radio :class="getPrimaryColor" v-model="filters.registerSituation" :label="true">Completo</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.registerSituation" :label="false">Pendente</el-radio>
                </div>
            </el-collapse-item>
        </el-collapse>
    </FiltersModal>

    <div class="ml-3">
        <el-input  @keyup.native.enter="filterSearchQuery" placeholder="Buscar" v-model="filterSearch"  :class="`${getPrimaryColor} filter`" clearable>
            <button class="btn" slot="append" @click="filterSearchQuery">
                <SearchIcon class="mx-0" size="16" />
            </button>
        </el-input>
        <h6 slot="append" class="regular">
            Busque pelo nome do usuário. Ex.: <span :class="`c-${getPrimaryColor}four`"> Felipe Leite. </span>
        </h6>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            filterSearch: '',
            filters: {
                userAllowedProfiles: '',
                registerSituation: ''
            },
        }
    },
    watch: {
        filterSearch(val) {
            if (!val.length) {
                this.filterSearchQuery()
            }
        }
    },
    methods: {
        formatTooltip(value) {
            let val = (value / 100).toFixed(2).toString().replace('.', ',')
            return `R$ ${val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
        },
        filterRequest() {
            this.$emit('filterStatus', this.filters)
            this.dialogVisible = false
        },
        filterSearchQuery() {
            this.$emit('filterSearch', this.filterSearch)
            this.dialogVisible = false
        },
        emptyFilters() {
            this.filterSearch = ''
            this.filters = {
                userAllowedProfiles: '',
                registerSituation: ''
            }
            this.$emit('emptyFilter', this.filters)
            this.dialogVisible = false
        },
    }
}
</script>

<style lang="scss" scoped>
.filter-button {
    font-weight: 500;
    height: 40px;
}
</style>
